import { useState } from 'react';
import styles from './Tab.module.scss';
import { LucideIcon } from 'lucide-react';

type TabItem = {
    id: string;
    label: string;
    icon?: LucideIcon;
    disabled?: boolean;
};

type TabProps = {
    variant?: 'default' | 'buttonStyle';
    tabs: TabItem[];
    activeTab?: string;
    onTabChange?: (tabId: string) => void;
} & React.HTMLAttributes<HTMLDivElement>;

export const Tab = ({ tabs, activeTab, onTabChange, className, variant = 'default', ...divProps }: TabProps) => {
    const [internalActiveTab, setInternalActiveTab] = useState<string>(activeTab || tabs[0]?.id || '');

    const currentActiveTab = activeTab !== undefined ? activeTab : internalActiveTab;

    const handleTabClick = (tabId: string, disabled?: boolean) => {
        if (disabled) return;

        if (activeTab === undefined) {
            setInternalActiveTab(tabId);
        }

        onTabChange?.(tabId);
    };

    const tabListClasses = [styles.tabContainer, styles[variant]].filter(Boolean).join(' ');

    return (
        <div className={`${tabListClasses} ${className || ''}`} {...divProps}>
            <div className={styles.tabList}>
                {tabs.map(({ id, label, disabled, icon: Icon }) => (
                    <button
                        key={id}
                        className={`${styles.tabButton} ${
                            currentActiveTab === id ? styles.active : ''
                        } ${disabled ? styles.disabled : ''}`}
                        onClick={() => handleTabClick(id, disabled)}
                        disabled={disabled}
                        type='button'
                    >
                        {Icon && <Icon size={16} />}
                        {label}
                    </button>
                ))}
            </div>
        </div>
    );
};
